import React from 'react';
import { toast } from 'react-hot-toast';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { fundTeam } from '../../web3/SFM-TeamsUtils';
import SocialTooltip from '../../social-wallet/tooltip';
//adding new campaign page
const SupportTeam = ({ teamId, teamName }) => {
  const [fundTokens, setFundTokens] = React.useState('');
  const [isSupportButtonClicked, setIsSupportButtonClicked] =
    React.useState(false);
  const supportTeam = async () => {
    try {
      setIsSupportButtonClicked(true);
      await fundTeam(teamId, fundTokens).then((e) => {
        console.log(e);

        toast.success(`you supported ${teamName} team successfully`);
        setIsSupportButtonClicked(false);
        window.location.reload()
      });
    } catch (e) {
      setIsSupportButtonClicked(false);
      if (e?.code == 'ACTION_REJECTED') {
        toast.error('You have canceled the transaction');
      } else {
        toast.error(e.message);
      }
    }
  };

  const popover = (
    <Popover id="popover-basic" bsPrefix="support-popover">
      <Popover.Header as="h3">Support</Popover.Header>
      <Popover.Body>
        <input
          className="form-control"
          name="fundTokens"
          placeholder="Tokens"
          onChange={(e) => setFundTokens(e.target.value)}
          value={fundTokens}
          type="number"
          min="0"
        />
        <button
          className="btn-inner-form btn-support btn-warning my-3 float-right"
          onClick={() => supportTeam()}
          disabled={fundTokens == ''}
        >
          {isSupportButtonClicked ? (
            <div className="lds-dual-ring"></div>
          ) : (
            'Support'
          )}
        </button>
      </Popover.Body>
    </Popover>
  );

  return (
    <SocialTooltip title={'Support Team'}>
      <label className="mb-0 pb-0">
        <OverlayTrigger
          trigger="click"
          placement="right"
          overlay={popover}
          rootClose={true}
        >
          <img src="assets/img/icon/donation.png" className="ml-3" alt="" />
        </OverlayTrigger>
      </label>
    </SocialTooltip>
  );
};

export default SupportTeam;
